import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=129ffa7e"
import script from "./fuwu.vue?vue&type=script&lang=js"
export * from "./fuwu.vue?vue&type=script&lang=js"
import style0 from "./fuwu.vue?vue&type=style&index=0&id=129ffa7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports